<template>
  <div>
    <b-card title="Create Employees Salaries">
      <b-row>
        <b-col md="4" cols="12">
          <b-form-group label="Salary Month" label-for="Month">
            <v-select
              v-model="salaryMonth"
              :options="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
              placeholder="Select Month"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Salary Date" label-for="Date">
            <datepicker
              v-model="salaryDate"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              :disabled-dates="{
                to: new Date(new Date().setDate(new Date().getDate() - 1)),
              }"
              placeholder="YYYY-MM-DD"
            ></datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table-simple style="border: none !important;" responsive class="no-scroll-table">
        <b-thead>
          <b-tr>
            <b-th>Employee</b-th>
            <b-th>Job Title</b-th>
            <b-th>Basic Salary</b-th>
            <b-th>Additional Salary</b-th>
            <b-th>Deduction Salary</b-th>
            <b-th> Description</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(employee, index) in employee_list" :key="index">
            <b-td>
              {{ employee.full_name }}
            </b-td>
            <b-td>
              {{ employee.job_title }} 
               </b-td>
            <b-td> {{ employee.basic_salary }} </b-td>
            <b-td>
              <b-form-input
                type="number"
                style="width: 5rem"
                v-model="employee.additional_salary"
              ></b-form-input>
            </b-td>
            <b-td>
              <b-form-input
                type="number"
                style="width: 5rem"
                v-model="employee.deduction_salary"
              ></b-form-input>
            </b-td>
            <b-td>
              <b-form-input
                style="width: 5rem"
                v-model="employee.description"
              ></b-form-input>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div class="pa-2 w-100">
        <b-row>
          <b-col
            cols="12"
c              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
              {{ $t("employee.employees") }}</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
             class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getEmployeesList()"
          >
            <b-pagination
              v-model="page"
              :total-rows="this.dataCount"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>

      <hr />
      <div class="d-flex justify-content-end">
        <b-button class="mx-2" variant="success" @click="printEmployeeSalaries()">
          Print
        </b-button>
        <b-button variant="primary" @click="submitItem">
          Calaculate Salary
        </b-button>
      </div>
    </b-card>
     <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="employeesSalariesPdf"
    >
      <section
        dir="rtl"
        class="pdf-content font-modify m-5 text-dark"
        slot="pdf-content"
      >
        <div dir="rtl" class="container mt-3">
     
          <table class="mt-1 print-table">
                        <tr class="table-sections" style="background-color: yellow">
                            <td colspan="5" class="text-center">رواتب موظفي مستشفى الوزيريه الاهلي لشهر {{ salaryMonth }} سنه 2024</td>
</tr>
            <tr class="table-sections" style="background-color: yellow"">
              <th scope="col" >ت</th>
              <th scope="col" >الاسم الثلاثي</th>
              <th scope="col" >العنوان الوظيفي</th>
              <th scope="col" >الملاحظات</th>
              <th scope="col" >التوقيع</th>
            </tr>
            <tbody>
              <tr class="table-sections" v-for="(employee, index) in employee_list" :key="index">
                <th class="table-sections" scope="row">{{ index + 1 }}</th>
                <td class="table-sections">{{ employee.full_name }}</td>
                <td class="table-sections">{{ employee.job_title || '' }}</td>
                <td class="table-sections">{{ employee.description }}</td>
                <td class="table-sections"></td>
              </tr>
            </tbody>
          </table>
          <div class="row justify-content-center mt-3">
            <div class="col-auto">
             <h5>المحاسب موفق عبدالكريم جاسم</h5>
            </div>
            <div class="col-auto">
              <h5 class="mx-3">مسؤؤول الحسابات مها علي عبدالرزاق</h5>
            </div>
          </div>
            <div class="row justify-content-center mt-3">
            <div class="col-auto">
             <h5>مدير المستشفى الدكتورة ابتهاج سيف الدين ثابت الالوسي</h5>
            </div>
            
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BBadge,
  BTableSimple,
  BTbody,
  BThead,
  BTr,
  BTd,
  BTh,
} from 'bootstrap-vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import VueHtml2pdf from 'vue-html2pdf';


export default {
  components: {
    BTableSimple,
    BTbody,
    BThead,
    BTr,
    BTd,
    BTh,
    BCard,
    BBadge,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    AutoComplete,
    Datepicker,
    vSelect,
    VueHtml2pdf
  },
  data() {
    return {
      take: 10,
      loading: true,
      salaryMonth: null,
      salaryDate: null,
      employee_list: [
        {
          employee_id: '',
          salary_date: '',
          salary_month: '',
          additional_salary: '',
          deduction_salary: 0,
          description: '',
        },
      ],
      data: [],
      params: {
        form: {},
        path: '',
      },

      page: 1,
    };
  },

  mounted() {
    this.getEmployeesList();
  },
  methods: {
    async getEmployeesList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/employees?page=${this.page}&take=${this.take}&sort=-id&include=job`;

      if (this.name) {
        url += `&filter[full_name]=${this.name}`;
      }
      if (this.jobTitle) {
        url += `&filter[job_title]=${this.jobTitle}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.employee_list = this.data.map((employee) => ({
        employee_id: employee.id,
        full_name: employee.full_name,
        job_title: employee.job ? employee.job.title : '',
        basic_salary: employee.base_salary,

        additional_salary: 0,
        deduction_salary: 0,
        description: '',
      }));
      this.loading = false;
    },

    formatExpDate(expDate) {
      // Create a new Date object from the selected date
      const date = new Date(expDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = '' + (date.getMonth() + 1); // getMonth() is zero-based
      let day = '' + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },

     printEmployeeSalaries() {
      this.$refs.employeesSalariesPdf.generatePdf();
    },

    submitItem() {
       this.employee_list.forEach((employee, index) => {
    this.$set(this.employee_list, index, {
      ...employee,
      salary_month: this.salaryMonth,
      salary_date: this.formatExpDate(this.salaryDate),
      additional_salary: employee.additional_salary,
      deduction_salary: employee.deduction_salary,
      description: employee.description,
    });
  });
       
        (this.params.form = { salaries: this.employee_list }),
          (this.params.path = `/employeeSalary`),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              this.$router.push({ name: 'employee' });

              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Created',
                  variant: 'success',
                },
              });
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item],
                    },
                  });
                }
              }
            });
    },
  },
};
</script>
<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

.print-table {
  width: 100%;
  border: 1px solid;
  font-size: 11px;
}




.table-sections {
  border: 1px solid;
  text-align:start;
  
 
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}



.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}



@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
